export const trackFirstPromoterReferral = ({ email, uid } = {}) => {
	try {
		if (typeof window === 'undefined' || typeof window.fpr !== 'function') return;

		const normalizedEmail = typeof email === 'string' ? email.trim().toLowerCase() : '';
		const normalizedUid = uid != null ? String(uid) : '';

		if (!normalizedEmail && !normalizedUid) return;

		const payload = {};
		if (normalizedEmail) payload.email = normalizedEmail;
		if (normalizedUid) payload.uid = normalizedUid;

		window.fpr('referral', payload);
	} catch (error) {
		// Keep signup flow resilient even when tracking fails.
		console.error('[FirstPromoter] Failed to track referral:', error);
	}
};
